import * as _axios from 'axios';
import token from './token.js';
import log from './log.js';
import axiosRetry from 'axios-retry';

var axios = _axios.create();

axios.interceptors.request.use(function (config) {
  return new Promise(function (resolve, reject) {
    token.get().then(function (token) {
      // we dont ALWAYS want the bearer token added to the headers
      if (!config.stripAuthorization) {
        config.headers['Authorization'] = "Bearer ".concat(token);
      }

      resolve(config);
    })["catch"](function (error) {
      log.warn('Unable to generate bearer token. Sending without Authorization header.', error);
      resolve(config);
    });
  });
}, function (error) {
  log.error('request error', error);
  return Promise.reject(error);
}); // https://github.com/softonic/axios-retry/issues/87

var retryDelay = function retryDelay() {
  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var seconds = Math.pow(2, retryNumber) * 1000;
  var randomMs = 1000 * Math.random();
  return seconds + randomMs;
};

var retryCondition = function retryCondition(err) {
  // window.navigator.onLine = if this is false then you're reliably offline, but it can give false positives.
  // isRetryableError = retry on Network Error & 5xx responses.
  return (typeof window === 'undefined' || window.navigator.onLine) && axiosRetry.isRetryableError(err);
};

axiosRetry(axios, {
  retries: 2,
  retryDelay: retryDelay,
  retryCondition: retryCondition
});
export default axios;